<template>
    <div class="profile-page">
        <section class="section-profile-cover section-shaped my-0">
            <div class="shape shape-style-1 shape-primary shape-skew alpha-4">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </section>
        <section class="section section-skew">
            <div class="container">
                <card shadow class="card-profile mt--300" no-body>
                    <div class="px-4">
                        <div class="text-center mt-5">
                            <h3>기업소개</h3>
                        </div>
                        <div class="mt-5 py-5 border-top">
                            <div class="row justify-content-center">
                                <div class="row col-lg-12" style="display: flex;">
                                    <div class="col-lg-6 card-div">
                                        <img src="img/theme/outdoor3.png" width="100%">
                                    </div>
                                    <div class="col-lg-6 card-div">
                                        <div class="header-text">
                                            고객이 편안할 수 있는 최우량 기업
                                        </div>
                                        <div>
                                            <p class="mid-line"></p>
                                        </div>
                                        <div>
                                            <p>
                                                다옴토건은 고객이 원하는 시설을 완성하기 위해 
                                                한 번의 선택으로 편안하게 맡길 수 있는 상품과 서비스를 제공하여, 
                                                고객의 미래 가치를 선도하는 리더 기업입니다.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="line"></div>
                            <div class="row justify-content-center">
                                <div class="row col-lg-12" style="display: flex;">
                                    <div class="col-lg-6 card-div">
                                        <img src="img/theme/outdoor3.png" width="100%">
                                    </div>
                                    <div class="col-lg-6 card-div">
                                        <div class="header-text">
                                            우수한 시공능력을 갖춘 회사
                                        </div>
                                        <div>
                                            <p class="mid-line"></p>
                                        </div>
                                        <div>
                                            <p>
                                                다옴토건은 2016년부터 우수한 실력으로 평가받아온 
                                                저희는 토목, 건축, 상하수도 공사를 종합적으로 수행하고 있습니다. 
                                                조직 구성원들은 전문성을 바탕으로 현장에서의 실력을 인정받고 있습니다
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="line"></div>
                            <div class="row card-header-itr" style="background-image: linear-gradient( rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3) ), url(img/theme/img-2-1200x1000.jpg);">
                                <div>
                                    모두의 공사가 편할 수 있도록<br>
                                    다옴토건의 경영원칙으로<br>
                                    기업의 가치를 성장합니다.<br>
                                </div>
                            </div>
                            <div class="row justify-content-center bg-white-gray" style="padding-top: 60px;">
                                <div class="row col-lg-12" style="display: flex;">
                                    <div class="col-lg-6 card-div">
                                        <img src="img/theme/outdoor3.png" width="100%">
                                    </div>
                                    <div class="col-lg-6 card-div">
                                        <div class="header-text">
                                            품질 우선
                                        </div>
                                        <div>
                                            <p class="mid-line"></p>
                                        </div>
                                        <div>
                                            <p>
                                                다옴토건은 항상 품질을 최우선으로 삼습니다. <br>
                                                제품과 서비스의 품질은 우리의 핵심 가치이며, 고객들이 신뢰할 수 있는 브랜드로 성장하기 위해 끊임없이 노력하고 있습니다.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row bg-white-gray">
                                <div class="line" style="width: 100%; border-bottom: 1px solid lightgray;"></div>
                            </div>
                            <div class="row justify-content-center bg-white-gray" style="padding-bottom: 45px;">
                                <div class="row col-lg-12" style="display: flex;">
                                    <div class="col-lg-6 card-div">
                                        <img src="img/theme/outdoor3.png" width="100%">
                                    </div>
                                    <div class="col-lg-6 card-div">
                                        <div class="header-text">
                                            투명성과 공정성
                                        </div>
                                        <div>
                                            <p class="mid-line"></p>
                                        </div>
                                        <div>
                                            <p>
                                                조직 전체에서 투명성과 공정성을 지키는 것을 중요하게 생각합니다. 모든 의사결정과 프로세스는 공개되고 공정하게 이루어지며, 이를 통해 우리의 이해관계자들과의 신뢰를 구축하고 유지하고 있습니다.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>
    </div>
</template>
<script>
export default {};
</script>
<style>
.line {
    border-bottom: 1px solid #e9ecef;
    padding-bottom: 40px;
    margin-bottom:  40px;
}

.mid-line{
    border-bottom: 3px solid black;
    width: 40px;
    border-radius: 1em;
    margin-bottom: 30px;
}

.header-text{
    font-size: 25px;
    font-weight: 300;
    padding-bottom: 10px;
}

.card-div{
    height: 300px;
    padding: 0px 30px 0px 30px;
}

.card-header-itr{
    color:#FFF; 
    text-align: center;
    font-size: 25px;
    font-weight: 300;
    padding: 60px 0 60px 0;
    display: flex;
    justify-content: center;
}

.bg-white-gray{
    background-color: #f3f3f3;
}
</style>
